import { api } from 'app/utils/api/helpers'

export const getPMSKeys = (agencyID, offerID) => {
  return api.get(`/pms/${agencyID}/offers/${offerID}/key`)
}
